// extracted by mini-css-extract-plugin
export default {"code":"bg_dc"};